import vanillaTextMask from "utilities/vendor/text-mask/2.0.0/js/vanillaTextMask";
import {maskInput} from "utilities/vendor/text-mask/2.0.0/js/vanillaTextMask";
import {conformToMask} from "utilities/vendor/text-mask/2.0.0/js/vanillaTextMask";
import createAutoCorrectedDatePipe from "utilities/vendor/text-mask/2.0.0/js/addons/createAutoCorrectedDatePipe";
import createNumberMask from "utilities/vendor/text-mask/2.0.0/js/addons/createNumberMask";
import emailMask from "utilities/vendor/text-mask/2.0.0/js/addons/emailMask";
import emailPipe from "utilities/vendor/text-mask/2.0.0/js/addons/emailPipe";
export default {
  createAutoCorrectedDatePipe,
  createNumberMask,
  emailMask,
  emailPipe,
  vanillaTextMask,
  conformToMask,
  maskInput,
};
